import React from 'react';
import './preloader.css';

const Preloader = () => {
  return (
    <div className="preloader-container">
      <div className="rotating-dots">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <p className="loading-message">Please wait, while submitting your response</p>
    </div>
  );
};

export default Preloader;
